import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

type passwordProps = {
  closeTooltip: any;
};
class PasswordPolicy extends Component<passwordProps, any> {
  render() {
    return (
      <div>
        <h3 className="password-policy-header">
          Password Policy
          <FontAwesomeIcon
            className="float-right"
            icon={faTimes}
            onClick={() => this.props.closeTooltip()}
          />
        </h3>
        <ul className="password-policy-list">
          <li>Passwords must be at least 14 characters long.</li>
          <li>Password should have at least 1 lowercase alphabet.</li>
          <li>Password should have at least 1 uppercase alphabet.</li>
          <li>Password should have at least 1 digit.</li>
          <li>Password should have at least 1 special characters.</li>
          <li>
            Password should not have username or a part of it with a caveat that
            the part should be more than 3 characters.
          </li>
          <li>User cannot reuse last 24 passwords.</li>
          <li>
            Password will get expired in 45 days. User will be prompted prior to
            5 days of expiry date.
          </li>
        </ul>
      </div>
    );
  }
}

export const PasswordPolicies = PasswordPolicy;
